import { ObjectSchema, number, object, string } from 'yup';
import { locale } from './../yup-locale';
import * as yup from 'yup';
import { MimicFolder } from './../../models/mimic-folder';
yup.setLocale(locale);

export const mimicFolderNameMaxLen = 20;

export function mimicFolderValidator(): ObjectSchema<MimicFolder> {
    return object({
        id: string().uuid().nonNullable().strict(),
        name: string().nonNullable().required().strict().max(mimicFolderNameMaxLen),
        vesselId: string().uuid().required().nonNullable().strict(),
        index: number().nonNullable().strict(),
    })
        .strict()
        .noUnknown() as ObjectSchema<MimicFolder>;
}
